import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M80-160v-640h800v640H80Zm80-80h640v-480H160v480Zm0 0v-480 480Z" })
});
export default SvgRectangle;
